export default "__VITE_ASSET__7bd2e118__"